import request from '../../services/request'
import { makeAuthRequest } from '../../utils/authedApi'

const api = {
  async recovery(data) {
    const result = await request('/users/password/recovery', {
      method: 'POST',
      body: data
    })

    return result
  },

  async reset(token, data) {
    const requester = makeAuthRequest(token)
    const result = await requester('/users/password/reset', {
      method: 'POST',
      body: data
    })

    return result.response.token
  }
}

export default api
